
<div
  ref="listRef"
  :class="classes(n())"
>
  <!-- 列表内容插槽 -->
  <slot />

  <!-- 加载状态 -->
  <div
    v-if="loading"
    :class="n('loading')"
  >
    <slot name="loading">
      <LoadingIcon
        :class="n('loading-icon')"
        width="32"
        height="32"
      />
      <span
        v-if="loadingText"
        :class="n('loading-text')"
      >
        {{ loadingText }}
      </span>
    </slot>
  </div>

  <!-- 加载完成状态 -->
  <div
    v-if="finished"
    :class="n('finished')"
  >
    <slot name="finished">
      <span
        v-if="finishedText"
        :class="n('finished-text')"
      >
        {{ finishedText }}
      </span>
    </slot>
  </div>

  <!-- 加载失败状态 -->
  <div
    v-if="error"
    :class="n('error')"
  >
    <slot name="error">
      <span
        v-if="errorText"
        :class="n('error-text')"
        @click="handleRetry"
      >
        {{ errorText }}
      </span>
    </slot>
  </div>
</div>
